import React, { FunctionComponent, ReactNode } from 'react'
import amplitude from 'amplitude-js'
import { Amplitude, AmplitudeProvider as Provider } from 'react-amplitude-hooks'
import { app } from '../../env'
import { useConsumerSelector } from '../../state'
import { useUserProperties } from './hooks'
import { setCookie } from 'nookies'
import { getDomain } from '../../utils/browser'

export interface AmplitudeUserProps {
  children: ReactNode
}

export interface AmplitudeProviderProps {
  children: ReactNode
}

export const AmplitudeUser: FunctionComponent<AmplitudeUserProps> = ({ children }) => {
  const userProperties = useUserProperties()
  return <Amplitude userProperties={userProperties}>{children}</Amplitude>
}

export const APT_AMP_D_ID = 'apt-amp-d-id'

/**
 * Dynamically wraps the AmplitudeProvider HOC from react-amplitude-hooks when in browser,
 * loading configuration and the consumer account from state.
 */
export const AmplitudeProvider: FunctionComponent<AmplitudeProviderProps> = ({ children }) => {
  const { uuid } = useConsumerSelector()
  const { AMPLITUDE_CLIENT_SIDE_ID } = app
  const hasValidApiKey = typeof AMPLITUDE_CLIENT_SIDE_ID !== 'undefined' && AMPLITUDE_CLIENT_SIDE_ID.length > 0
  const amplitudeInstance = amplitude.getInstance()
  setCookie(null, APT_AMP_D_ID, amplitudeInstance.getDeviceId(), {
    path: '/',
    sameSite: 'none',
    secure: true,
    maxAge: 60 * 30, // 30 minutes
    domain: getDomain(),
  })

  if (hasValidApiKey) {
    return (
      <Provider amplitudeInstance={amplitudeInstance} apiKey={AMPLITUDE_CLIENT_SIDE_ID} userId={uuid}>
        <AmplitudeUser>{children}</AmplitudeUser>
      </Provider>
    )
  } else {
    return <>{children}</>
  }
}
